import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SwitchBanner.module.scss';

export interface SwitchBannerProps {
  title: string;
  description?: string;
  button?: React.ReactNode;
}

const SwitchBanner: React.FC<SwitchBannerProps> = ({ title, description, button }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <div className={styles.switchBanner}>
      <div className={styles.content}>
        <div className={styles.badge}>{t('new')}</div>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.seperator}></div>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      {button && <div className={styles.buttons}>{button}</div>}
    </div>
  );
};

export default SwitchBanner;
